import { Link, useLocation } from 'react-router-dom';
import ChooseAFile from "./ChooseAFile";
import { ExtendedMarkdown, NewTab, InputInvalidMessage } from './UtilityComponents';

export default function AdvisorSectionContent({
    index,
    oneShowInput,
    updatedItem,
    oneSectionData,
    setUpdatedSectionsData,
    updatedImgFiles,
    setUpdatedImgFiles,
    withImage = true,
    children,
}) {
    const { pathname } = useLocation();

    const isProfilePage = pathname === '/member-zone/profile';

    const updateSection = (patch) => {
        setUpdatedSectionsData(prev => {
            const next = [...prev];
            const current = next[index] || {};
            next[index] = { ...current, ...patch };
            return next;
        });
    };
    const makeFieldChangeHandler = (field, parser = v => v) => (e) => {
        const value = parser(e.target.value);
        updateSection({ [field]: value });
    };
    const handleTitleChange = makeFieldChangeHandler('title');
    const handleTextChange = makeFieldChangeHandler('text');
    const handleTypeChange = makeFieldChangeHandler('type', v => parseInt(v, 10));
    const handleSortIndexChange = makeFieldChangeHandler(
        'sortIndex',
        v => (v === '' ? '' : parseInt(v, 10))
    );


    return (
        <>
            {/* Display inputs when editing */}
            {oneShowInput && isProfilePage && (
                <>
                    {/* Title input */}
                    <b>Title</b>&nbsp;
                    <InputInvalidMessage condition={updatedItem.title === ''} />
                    <input
                        type="text"
                        placeholder="Title"
                        value={updatedItem.title || ''}
                        onChange={handleTitleChange}
                        style={{ marginTop: '5px', marginBottom: '5px' }}
                    />

                    {/* Content input */}
                    <b>Content</b>&nbsp;
                    <span style={{ fontSize: '0.8em' }}>
                        (Support the <NewTab href='https://www.markdownguide.org'>Markdown</NewTab> syntax.)
                    </span>&nbsp;
                    <InputInvalidMessage condition={updatedItem.text === ''} />
                    <textarea
                        placeholder="Content (Markdown supported. E.g., **bold**, *italic*, [link](url))"
                        value={updatedItem.text || ''}
                        onChange={handleTextChange}
                        style={{ marginTop: '5px', marginBottom: '5px', height: '20em', fontSize: '0.8em' }}
                    />
                    
                    {/* Type selection */}
                    <b>Where to display?</b>
                    <select value={updatedItem.type}
                        onChange={handleTypeChange}
                        style={{ marginTop: '5px', marginBottom: '5px' }}
                    >
                        <option value={0}>Homepage, Members, Advisor, and Profile</option>
                        <option value={1}>Only Advisor and Profile</option>
                    </select>

                    {/* Sort index selection */}
                    <b>Order</b>&nbsp;
                    <span style={{ fontSize: '0.8em' }}>
                        (Sections with an image are always displayed before those without, regardless of the "Order" value.)
                    </span>
                    <select value={updatedItem.sortIndex || ''}
                        onChange={handleSortIndexChange}
                        style={{ marginTop: '5px', marginBottom: '5px' }}
                    >
                        {children}
                    </select>

                    {/* Image upload */}
                    {withImage && (
                        <>
                            <b>Image</b>&nbsp;
                            <span style={{ fontSize: '0.8em' }}>
                                (Optional. Replace the current one.)
                            </span>
                            <div style={{ marginTop: '5px', marginBottom: '5px' }}>
                                <ChooseAFile
                                    index={index}
                                    accept={'.jpg, .jpeg, .png'} // need a space after comma
                                    files={updatedImgFiles}
                                    setFiles={setUpdatedImgFiles}
                                    alwaysDark={true}
                                />
                            </div> 
                        </>
                    )}
                </>
            )}

            {/* Display content when not editing */}
            {!oneShowInput && (
                <>
                    <h2>{oneSectionData.title}</h2>
                    <ExtendedMarkdown>
                        {oneSectionData.text}
                    </ExtendedMarkdown>
                    {isProfilePage && (
                        <>
                            <div style={{ marginTop: '5px', marginBottom: '5px' }}>
                                <b>Where to display:</b> {oneSectionData.type === 0 ? (
                                    <span>
                                        <Link to='/'>Homepage</Link>,&nbsp;
                                        <Link to='/members'>Members</Link>,&nbsp;
                                        <Link to='/advisor'>Advisor</Link>, and&nbsp;
                                        <Link to='/member-zone/profile'>Profile</Link>
                                    </span>
                                ) : (
                                    <span>
                                        Only&nbsp;
                                        <Link to='/advisor'>Advisor</Link> and&nbsp;
                                        <Link to='/member-zone/profile'>Profile</Link>
                                    </span>
                                )}
                            </div>
                            <div style={{ marginTop: '5px', marginBottom: '5px' }}>
                                <b>Order:</b> {oneSectionData.sortIndex}
                            </div>
                        </>
                    )}
                </>
            )}
        </>
    );
}